<template>
	<button @click="clockOut" class="btn btn-danger btn-lg mh-btn btn-block">Clock Out</button>
</template>

<script>
	import moment from "moment"

	export default {
		name: 'ClockOutForm',
		props: {
			currentTimeClockShift: null,
			notes: null
		},
		computed: {
			isNotesValid: function () {
				if (this.notes == null || this.notes == "") {
					this.$store.commit("Toasts/showError", { title: "Notes", content: "Notes are required" })

					return false
				}

				return true
			},
			clientServices: function () {
				return this.$store.state.ClientServices.clientServices
			}
		},
		methods: {
			isFormValid: function () {
				return this.isNotesValid
			},
			clockOut: function () {
				if (!this.isFormValid())
					return

				var from = moment(this.currentTimeClockShift.servicedate, "DD/MM/YYYY hh:mm:ss a");
				var now = moment();

				var parameters = {
					timesheetId: this.currentTimeClockShift.timesheetid,
					hasShift: true,
					shiftId: this.currentTimeClockShift.servicescheduleid,
					shiftName: this.currentTimeClockShift.shifttask,
					userId: this.currentTimeClockShift.employeeid,
					clientId: this.currentTimeClockShift.clientid,
					dateFrom: from.format("YYYY-MM-DD hh:mm:ss a"),
					dateTo: now.format("YYYY-MM-DD hh:mm:ss a"),
					totalHours: moment.duration(now.diff(from)).asHours(),
					travelKm: 0,
					transportKm: 0,
					serviceId: this.currentTimeClockShift.servicetypeid == "0" ? -1 : this.currentTimeClockShift.servicetypeid,
					billable: this.currentTimeClockShift.servicetypeid != "0",
					serviceScheduleStatus: 2,
					notetagIds: "",
					notes: this.notes,
					cancellationPolicyId: "0",
					additionalRosterComments: this.currentTimeClockShift.shiftcomments,
					SendEmailNotification: false
				}

				var $this = this

				this.$store.dispatch("Shifts/createTimesheet", parameters).then(function () {
					$this.$emit("save-form")
				})
			}
		}
	}
</script>

<style scoped>
</style>